import { SharedAppState } from 'shared/state/store.shared';

export const showSpinnerByActionTypes = (actions: string[]) => {
	return (state: SharedAppState) => {
		return actions.find(e => state.generalSettings.showSpinner[e]) ? true : false;
	};
};
